import { FIELD_TYPE_DATE, FIELD_TYPE_ENUM, FIELD_TYPE_FLOAT, FIELD_TYPE_MULTISELECT, FIELD_TYPE_STRING, JSON_PATCH_OP_ADD, JSON_PATCH_OP_REMOVE, JSON_PATCH_OP_REPLACE, JSON_PATCH_OP_TEST } from './constants';

var bpfrpt_proptype_FieldValue = PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.arrayOf(PropTypes.any)]);
var bpfrpt_proptype_Fields = {};
var bpfrpt_proptype_FieldType = PropTypes.oneOfType([PropTypes.any, PropTypes.any, PropTypes.any, PropTypes.any, PropTypes.any]);
var bpfrpt_proptype_TemplateFieldOption = {
    id: PropTypes.string,
    key: PropTypes.string.isRequired
};
var bpfrpt_proptype_TemplateField = {
    id: PropTypes.string.isRequired,
    type: PropTypes.oneOfType([PropTypes.any, PropTypes.any, PropTypes.any, PropTypes.any, PropTypes.any]).isRequired,
    key: PropTypes.string.isRequired,
    displayName: PropTypes.string.isRequired,
    description: PropTypes.string,
    isHidden: PropTypes.bool,
    // V2
    hidden: PropTypes.bool,
    // V3
    options: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
        key: PropTypes.string.isRequired
    }))
};
var bpfrpt_proptype_Template = {
    id: PropTypes.string.isRequired,
    scope: PropTypes.string.isRequired,
    templateKey: PropTypes.string.isRequired,
    displayName: PropTypes.string,
    fields: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        type: PropTypes.oneOfType([PropTypes.any, PropTypes.any, PropTypes.any, PropTypes.any, PropTypes.any]).isRequired,
        key: PropTypes.string.isRequired,
        displayName: PropTypes.string.isRequired,
        description: PropTypes.string,
        isHidden: PropTypes.bool,
        hidden: PropTypes.bool,
        options: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.string,
            key: PropTypes.string.isRequired
        }))
    })),
    isHidden: PropTypes.bool,
    // V2
    hidden: PropTypes.bool
};
var bpfrpt_proptype_CascadePolicyType = {
    canEdit: PropTypes.bool,
    id: PropTypes.string
};
var bpfrpt_proptype_InstanceType = {
    id: PropTypes.string.isRequired,
    data: PropTypes.shape({}).isRequired,
    canEdit: PropTypes.bool.isRequired,
    cascadePolicy: PropTypes.shape({
        canEdit: PropTypes.bool,
        id: PropTypes.string
    })
};
var bpfrpt_proptype_Editor = {
    hasError: PropTypes.bool,
    instance: PropTypes.shape({
        id: PropTypes.string.isRequired,
        data: PropTypes.shape({}).isRequired,
        canEdit: PropTypes.bool.isRequired,
        cascadePolicy: PropTypes.shape({
            canEdit: PropTypes.bool,
            id: PropTypes.string
        })
    }).isRequired,
    isDirty: PropTypes.bool,
    template: PropTypes.shape({
        id: PropTypes.string.isRequired,
        scope: PropTypes.string.isRequired,
        templateKey: PropTypes.string.isRequired,
        displayName: PropTypes.string,
        fields: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.string.isRequired,
            type: PropTypes.oneOfType([PropTypes.any, PropTypes.any, PropTypes.any, PropTypes.any, PropTypes.any]).isRequired,
            key: PropTypes.string.isRequired,
            displayName: PropTypes.string.isRequired,
            description: PropTypes.string,
            isHidden: PropTypes.bool,
            hidden: PropTypes.bool,
            options: PropTypes.arrayOf(PropTypes.shape({
                id: PropTypes.string,
                key: PropTypes.string.isRequired
            }))
        })),
        isHidden: PropTypes.bool,
        hidden: PropTypes.bool
    }).isRequired
};
var bpfrpt_proptype_JSONPatch = {
    op: PropTypes.oneOfType([PropTypes.any, PropTypes.any, PropTypes.any, PropTypes.any]).isRequired,
    path: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.arrayOf(PropTypes.any)])
};
var bpfrpt_proptype_JSONPatchOperations = PropTypes.arrayOf(PropTypes.shape({
    op: PropTypes.oneOfType([PropTypes.any, PropTypes.any, PropTypes.any, PropTypes.any]).isRequired,
    path: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.arrayOf(PropTypes.any)])
}));
var bpfrpt_proptype_CascadingPolicyData = {
    id: PropTypes.string,
    isEnabled: PropTypes.bool.isRequired,
    overwrite: PropTypes.bool.isRequired
};
var bpfrpt_proptype_CellData = {
    cellData: function cellData(props, propName, componentName) {
        if (!Object.prototype.hasOwnProperty.call(props, propName)) {
            throw new Error('Prop `' + propName + '` has type \'any\' or \'mixed\', but was not provided to `' + componentName + '`. Pass undefined or any other value.');
        }
    },
    columnData: PropTypes.any,
    columnIndex: PropTypes.number.isRequired,
    dataKey: PropTypes.string.isRequired,
    isScrolling: PropTypes.bool,
    parent: PropTypes.object,
    rowData: PropTypes.object.isRequired,
    rowIndex: PropTypes.number.isRequired
};
var bpfrpt_proptype_HeaderData = {
    columnData: PropTypes.any,
    dataKey: PropTypes.string.isRequired,
    disableSort: PropTypes.bool,
    label: PropTypes.string.isRequired,
    sortBy: PropTypes.string,
    SortDirection: PropTypes.any
};
import PropTypes from 'prop-types';
export { bpfrpt_proptype_FieldValue };
export { bpfrpt_proptype_Fields };
export { bpfrpt_proptype_FieldType };
export { bpfrpt_proptype_TemplateFieldOption };
export { bpfrpt_proptype_TemplateField };
export { bpfrpt_proptype_Template };
export { bpfrpt_proptype_CascadePolicyType };
export { bpfrpt_proptype_InstanceType };
export { bpfrpt_proptype_Editor };
export { bpfrpt_proptype_JSONPatch };
export { bpfrpt_proptype_JSONPatchOperations };
export { bpfrpt_proptype_CascadingPolicyData };
export { bpfrpt_proptype_CellData };
export { bpfrpt_proptype_HeaderData };